import type { IChatbotMessage } from "../../../entities/chatbot-message.entity";
import { SenderTypeEnum } from "../../../enums/sender-type.enum";
import type { IChatbotMessageHandlerService } from "./chatbot-message-handler.service.interface";

export class ChatbotMessageHandlerService implements IChatbotMessageHandlerService {
  public generateUserMessage(message: string): IChatbotMessage {
    return {
      text: message,
      senderType: SenderTypeEnum.USER,
      feedback: null,
      negativeFeedbackReason: null,
    };
  }

  public generateAssistantMessage(message: string): IChatbotMessage {
    return {
      text: message,
      senderType: SenderTypeEnum.ASSISTANT,
      feedback: null,
      negativeFeedbackReason: null,
    };
  }
}
